'use client'

import { FC } from 'react'
import useI18n from 'Hooks/useI18n'
import { ANNIVERSARY_DEADLINE_TIME } from '@/constant/date'
import GemRewardDisplay from './components/GemRewardDisplay'
import CountdownTimer from './components/CountdownTimer'

const AnniversaryBannerCard: FC = () => {
  const { t } = useI18n()

  return (
    <div
      className="relative flex h-full w-full flex-col items-center justify-start bg-cover bg-center px-4 pb-4 pt-5"
      style={{
        backgroundImage: 'url(/activity/bg_anniversary.png)',
      }}
    >
      {/* 标题区 */}
      <div className="flex flex-col items-center justify-center text-center">
        <p
          style={{
            fontSize: '15px',
            fontWeight: '500',
            color: '#FFFFFF',
            lineHeight: '18px',
            textShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
          }}
        >
          {t('1st Anniversary Sale')}
        </p>
        <p
          style={{
            fontSize: '11px',
            fontWeight: '400',
            color: '#FFFFFF',
            opacity: 0.7,
            lineHeight: '14px',
            marginTop: '4px',
          }}
        >
          {t('Get Triple Gems Now!')}
        </p>
      </div>

      {/* 底部容器 - 奖励、倒计时、按钮 */}
      <div className="flex w-full flex-1 flex-col items-center justify-end gap-2 pb-4">
        {/* 奖励展示 */}
        <GemRewardDisplay />

        {/* 倒计时 */}
        <CountdownTimer deadline={ANNIVERSARY_DEADLINE_TIME} />

        {/* 查看按钮 */}
        <div className="w-full">
          <button className="h-[26px] w-full rounded-full bg-white/20 text-[13px] font-medium leading-[26px] text-white hover:bg-white/30">
            {t('View')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default AnniversaryBannerCard
